module.exports = __webpack_public_path__ + "img/settings-sorting.67dcc553.svg";